import { doc, onSnapshot } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import PLANES_CONFIG from "../config/planes.json";
import { db, functions } from "../services/firebase";
import { formatDate, toDate } from "./format";

export { PLANES_CONFIG };

export const PLAN_NAMES = Object.fromEntries(Object.entries(PLANES_CONFIG.planes).map(([id, p]) => [id, p.nombre]));

// Mismo criterio que planVigente() en functions/planes.js: un plan vencido es gratis aunque el servidor
// todavía no lo haya pasado (vencerPlanes corre cada hora).
export function currentPlan(datos = {}, now = Date.now()) {
  const plan = datos.plan in PLANES_CONFIG.planes ? datos.plan : "gratis";
  const vence = toDate(datos.planVence)?.getTime() ?? null;
  if (plan !== "gratis" && vence != null && vence <= now) {
    return { plan: "gratis", planVence: null, enPrueba: false, esFundador: !!datos.esFundador, vencido: true };
  }
  return { plan, planVence: plan === "gratis" ? null : vence, enPrueba: plan !== "gratis" && !!datos.enPrueba, esFundador: !!datos.esFundador, vencido: false };
}

// "Clínica · prueba gratis · vence el 12 nov 2026", "Gratis", "Laboratorio · Fundador · vence el …".
export function describePlan(vigente) {
  const partes = [PLAN_NAMES[vigente.plan] || vigente.plan];
  if (vigente.enPrueba) partes.push("prueba gratis");
  if (vigente.esFundador && vigente.plan !== "gratis") partes.push("Fundador");
  if (vigente.plan !== "gratis") partes.push(vigente.planVence ? `vence el ${formatDate(vigente.planVence)}` : "sin vencimiento");
  return partes.join(" · ");
}

// Filtro del panel: gratis, en prueba, clínica, laboratorio (sin prueba) y fundador.
export const PLAN_FILTERS = [
  { value: "gratis", label: "Gratis" },
  { value: "prueba", label: "En prueba" },
  { value: "clinica", label: "Clínica" },
  { value: "laboratorio", label: "Laboratorio" },
  { value: "fundador", label: "Fundador" },
];

export function matchesPlanFilter(vigente, filter) {
  if (!filter) return true;
  if (filter === "fundador") return vigente.esFundador;
  if (filter === "prueba") return vigente.enPrueba;
  if (filter === "gratis") return vigente.plan === "gratis";
  return vigente.plan === filter && !vigente.enPrueba;
}

// Campos de plan de usuarios/{uid} (los escribe solo el servidor). Aparte del perfil a propósito:
// Mi cuenta guarda el perfil completo y no tiene que reescribir estos campos.
export function subscribeToPlan(uid, onData, onError) {
  return onSnapshot(
    doc(db, "usuarios", uid),
    (snapshot) => {
      const d = snapshot.data() || {};
      onData({ plan: d.plan, planVence: d.planVence ?? null, enPrueba: d.enPrueba, esFundador: d.esFundador, suscripcion: d.suscripcion ?? null, facturacion: d.facturacion ?? null });
    },
    onError
  );
}

// El rol ya no se escribe desde la app (firestore.rules): lo cambia el servidor y ajusta el plan.
export const changeMyRole = async (rol) => (await httpsCallable(functions, "cambiarMiRol")({ rol })).data;
